import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Form, Button} from 'semantic-ui-react';

class NoteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'Internal',
            note: ""
        }
    }
    
    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <Form size="small">
                        <Form.Select options={[
                            {value: 'Internal', text: "Internal Note"},
                            {value: 'Public', text: "Public Note"},
                        ]} size='mini'
                            fluid value={this.state.type}
                            onChange={(e, {value}) => {
                                this.setState({
                                    type: value
                                })
                            }} />
                        <Form.TextArea
                            value={this.state.note}
                            onChange={(e, {value}) => {
                                this.setState({
                                    note: value
                                })
                            }}
                        />
                        <Button floated='right'
                            onClick={() => {
                                this.props.onSaveClose(this.state);
                            }}
                            size='mini' color='teal'>Save Note</Button>
                    </Form>
                </div>
            </div>
        )
    }
}

NoteModal.propTypes = {
    onSaveClose: PropTypes.func.isRequired
};

export default NoteModal


// WEBPACK FOOTER //
// ./src/components/orders/parts/NoteModal.js